import React from 'react';
import { PhoneCall } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const MobileStickyFAB = () => {
  return (
    <div className="fixed bottom-4 right-4 z-50 md:hidden">
      <Button 
        asChild
        size="lg"
        className="h-14 w-14 rounded-full shadow-lg bg-primary hover:bg-primary/90 text-primary-foreground"
        aria-label="Call Safeway Roofing & Chimney"
      >
        <a href="tel:+16317107600">
          <PhoneCall className="w-6 h-6" />
        </a>
      </Button>
    </div>
  );
};